import { list as listSchedules } from 'api/playlist-schedules'
import { listAll as listPlaylists, update as updatePlaylist } from 'api/playlists'
import { deleteScreen, list, setFolder, sync, unsync, update } from 'api/screens'
import CreateADigitalDisplay from 'components/CreateADigitalDisplay'
import DeleteModal from 'components/DeleteModal'
import Loader from 'components/Loader'
import LoaderButton from 'components/LoaderButton'
import PreviewModal from 'components/PreviewModal'
import RefreshModal from 'components/RefreshModal'
import Tooltip from 'components/Tooltip'
import UsageBanner from 'components/UsageBanner'
import CreateFolder from 'components/create-folder/CreateFolder'
import DeleteFolder from 'components/delete-folder/DeleteFolder'
import LargeHeader from 'components/headers/LargeHeader'
import ListFolders from 'components/list-folders/ListFolders'
import Panel from 'components/panel/Panel'
import Toolbar, { ToolbarGroup } from 'components/toolbar/Toolbar'
import UpdateFolder from 'components/update-folder/UpdateFolder'
import { useEffect, useState } from 'react'
import {
  Alert,
  Badge,
  Button,
  ButtonGroup,
  Dropdown,
  DropdownButton,
} from 'react-bootstrap'
import {
  ArrowLeftCircle,
  ArrowRepeat,
  CheckCircleFill,
  CircleFill,
  Display,
  Folder,
  House,
  Pencil,
  Stopwatch,
  StopwatchFill,
  Trash,
  XCircleFill,
} from 'react-bootstrap-icons'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'
import { Link, useParams } from 'react-router-dom'
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share'
import styles from './Screens.module.scss'

function Screens(props) {
  const [loading, setLoading] = useState(true)
  const [updating, setUpdating] = useState(false)
  const [screens, setScreens] = useState({})
  const [displayUrl, setDisplayUrl] = useState('')
  const [previewUrl, setPreviewUrl] = useState('')
  const [previewOrientation, setPreviewOrientation] = useState('landscape')
  const [previewAspectRatio, setPreviewAspectRatio] = useState('16:9')
  const [previewOpen, setPreviewOpen] = useState(false)
  const [deleting, setDeleting] = useState(false)
  const [deleteOpen, setDeleteOpen] = useState(false)
  const [deleteId, setDeleteId] = useState('')
  const [deleteIndex, setDeleteIndex] = useState('')
  const [deleteError, setDeleteError] = useState('')
  const [playlists, setPlaylists] = useState()
  const [schedules, setSchedules] = useState()

  const { folderId } = useParams()

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)

      const [_playlists, _schedules, _screens] = await Promise.all([
        listPlaylists(),
        listSchedules(),
        list(15, 1, folderId),
      ])

      setPlaylists(_playlists.data)
      setSchedules(_schedules.data)
      setScreens(_screens)
      setLoading(false)
    }

    fetchData()
  }, [folderId])

  const handleClickPreview = (url, previewUrl, orientation, aspectRatio) => {
    setDisplayUrl(url)
    setPreviewUrl(previewUrl)
    setPreviewOrientation(orientation)
    setPreviewAspectRatio(aspectRatio)
    setPreviewOpen(true)
  }

  const handleOpenDeleteDialog = (id, index) => {
    setDeleteId(id)
    setDeleteIndex(index)
    setDeleteOpen(true)
  }

  const handleCloseDeleteDialog = () => {
    setDeleteOpen(false)
  }

  const handleDelete = async (id, index) => {
    setDeleteError(false)
    setDeleting(true)
    const success = await deleteScreen(id)

    if (success) {
      const res = await list()
      setScreens(res)
      setDeleteOpen(false)
    } else {
      setDeleteError(true)
    }

    setDeleting(false)
  }

  const reloadData = async () => {
    const res = await list(15, 1, folderId)
    setScreens(res)
  }

  const handleChangeFolder = (screenId, folderId) => {
    const newScreens = { ...screens }
    const newData = screens.data.filter(x => x.id !== screenId)
    newScreens.data = newData
    setScreens(newScreens)
    setFolder({ screen_id: screenId, folder_id: folderId })
  }

  const handleChangeDisplayItem = async (screenId, itemId) => {
    setUpdating(true)
    await update(screenId, {
      display_item_id: itemId,
    })
    const screens = await list(15, 1, folderId)
    setScreens(screens)
    setUpdating(false)
  }

  if (loading) {
    return <Loader />
  }

  if (screens.meta.playlist_count === 0) {
    return (
      <div style={{ maxWidth: '400px', margin: 'auto' }}>
        <CreateADigitalDisplay />
      </div>
    )
  }

  return (
    <Container>
      <LargeHeader>Displays</LargeHeader>

      <UsageBanner
        used={screens.meta.usage.used}
        limit={screens.meta.usage.limit}
        exceededLimit={screens.meta.usage.used >= screens.meta.usage.limit}>
        {' '}
        displays created
      </UsageBanner>

      <ScreensToolbar
        state={screens}
        parentFolderId={
          screens.meta.folder.id !== '' ? screens.meta.parent_folder.id : undefined
        }
        reloadData={reloadData}
      />

      <ListFolders
        folders={screens.meta.child_folders.map(x => {
          x.otherProps = { as: Link, to: `/displays/${x.id}` }
          return x
        })}
      />

      <Panel>
        {screens.data.length === 0 ? (
          <div>No displays created yet.</div>
        ) : (
          <Table responsive>
            <thead>
              <tr>
                <th>Name</th>
                {screens.meta.show_status && <th className='text-center'>Status</th>}
                <th>Schedule/Playlist</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {screens.data.map((x, index) => (
                <tr key={x.id}>
                  <td>
                    {x.name}
                    {x.synced && (
                      <Tooltip label='Synced'>
                        <StopwatchFill className='ml-2 text-primary' />
                      </Tooltip>
                    )}
                  </td>
                  {screens.meta.show_status && (
                    <td className='text-center'>
                      {x.status === 'not_in_use' ? (
                        <Tooltip label='Not in use'>
                          <CircleFill color='#6c757d' />
                        </Tooltip>
                      ) : x.status === 'online' ? (
                        <Tooltip label='Online'>
                          <CheckCircleFill color='#63d75c' />
                        </Tooltip>
                      ) : (
                        <Tooltip label='Offline'>
                          <XCircleFill color='#dc3545' />
                        </Tooltip>
                      )}
                    </td>
                  )}
                  <td className='pt-2'>
                    <Form.Control
                      as='select'
                      placeholder='Schedule or playlist to display'
                      name='display_item_id'
                      value={
                        x.schedule?.id
                          ? 's|' + x.schedule.id
                          : x.playlist?.id
                            ? 'p|' + x.playlist.id
                            : null
                      }
                      onChange={e => {
                        handleChangeDisplayItem(x.id, e.target.value)
                      }}>
                      <option value='' disabled>
                        Please select
                      </option>

                      {schedules.length > 0 && (
                        <>
                          <option value='' disabled style={{ fontSize: '1.4rem' }}>
                            Schedules
                          </option>
                          {schedules.map(x => (
                            <option key={x.id} value={`s|${x.id}`}>
                              {x.name}
                            </option>
                          ))}
                        </>
                      )}

                      {playlists.length > 0 && (
                        <>
                          <option value='' disabled style={{ fontSize: '1.4rem' }}>
                            Playlists
                          </option>
                          {playlists.map(x => (
                            <option key={x.id} value={`p|${x.id}`}>
                              {x.name}
                            </option>
                          ))}
                        </>
                      )}
                    </Form.Control>
                  </td>
                  <td className='row-actions'>
                    <Tooltip label='Change folder'>
                      <DropdownButton
                        size='xs'
                        className={`${styles.dropdown} mr-1 d-inline-block`}
                        name='display-images-for'
                        title={<Folder />}>
                        {screens.meta.folders.map(folder => (
                          <Dropdown.Item
                            key={`${x.id}-${folder.id}`}
                            onClick={() => handleChangeFolder(x.id, folder.id)}>
                            {folder.name}
                          </Dropdown.Item>
                        ))}
                      </DropdownButton>
                    </Tooltip>
                    <Tooltip label='Edit Display'>
                      <Button
                        className='mr-1 px-2'
                        variant='primary'
                        size='sm'
                        as={Link}
                        to={`/displays/update/${x.id}`}>
                        <Pencil />
                      </Button>
                    </Tooltip>
                    <RefreshDisplayButton id={x.playlist.id} />
                    <Tooltip label='View Display URL'>
                      <Button
                        className='mr-1 px-2'
                        variant='primary'
                        size='sm'
                        onClick={() =>
                          handleClickPreview(
                            x.url,
                            x.preview_url,
                            x.playlist.orientation,
                            x.playlist.aspect_ratio
                          )
                        }>
                        <Display />
                      </Button>
                    </Tooltip>
                    <Tooltip label='Delete Display'>
                      <Button
                        variant='danger'
                        className='px-2'
                        size='sm'
                        onClick={() => handleOpenDeleteDialog(x.id, index)}>
                        <Trash />
                      </Button>
                    </Tooltip>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Panel>

      <PreviewModal
        open={previewOpen}
        onHide={() => {
          setPreviewOpen(false)
        }}
        orientation={previewOrientation}
        aspectRatio={previewAspectRatio}
        url={previewUrl}>
        <div className='mb-2'>You can use the below URL for your displays.</div>
        <div className='mb-3'>
          <strong>{displayUrl}</strong>
        </div>
        <div className='mb-4'>
          <LinkedinShareButton url={previewUrl} className='mr-1'>
            <LinkedinIcon size={32} round={true} />
          </LinkedinShareButton>
          <FacebookShareButton url={previewUrl} className='mr-1'>
            <FacebookIcon size={32} round={true} />
          </FacebookShareButton>
          <TwitterShareButton url={previewUrl} className='mr-1'>
            <TwitterIcon size={32} round={true} />
          </TwitterShareButton>
        </div>
      </PreviewModal>

      <DeleteModal
        show={deleteOpen}
        onHide={handleCloseDeleteDialog}
        deleting={deleting}
        onDelete={() => handleDelete(deleteId, deleteIndex)}
        errorMessage={deleteError}
      />
      {updating && (
        <div className='fixed-bottom mb-4 ml-4'>
          <Spinner animation='border' />
        </div>
      )}
    </Container>
  )
}

function RefreshDisplayButton({ id }) {
  const [refreshOpen, setRefreshOpen] = useState(false)
  const [refreshing, setRefreshing] = useState(false)
  const [refreshed, setRefreshed] = useState(false)

  const handleClickRefresh = () => {
    setRefreshOpen(true)
  }

  const handleRefresh = () => {
    setRefreshing(true)
    updatePlaylist(id, {})
    setRefreshed(true)
    setRefreshing(false)
    setRefreshOpen(false)
  }

  return (
    <>
      <Tooltip
        label={
          refreshed
            ? 'Refresh signal sent to display, allow up to 10 minutes for displays to reload'
            : 'Refresh Display'
        }>
        <Button
          disabled={refreshed}
          className='mr-1 px-2'
          variant='primary'
          size='sm'
          onClick={handleClickRefresh}>
          <ArrowRepeat />
        </Button>
      </Tooltip>
      <RefreshModal
        open={refreshOpen}
        onHide={() => {
          setRefreshOpen(false)
        }}
        loading={refreshing}
        onSubmit={handleRefresh}
        id={id}
      />
    </>
  )
}

function ScreensToolbar({ state, parentFolderId, reloadData }) {
  const { folderId } = useParams()
  const [syncOpen, setSyncOpen] = useState(false)
  const [syncing, setSyncing] = useState(false)
  const [syncSuccess, setSyncSuccess] = useState(null)
  const [syncError, setSyncError] = useState(false)
  const [unsyncOpen, setUnsyncOpen] = useState(false)
  const [unsyncing, setUnsyncing] = useState(false)
  const [unsyncSuccess, setUnsyncSuccess] = useState(null)
  const [unsyncError, setUnsyncError] = useState(false)

  const handleSync = async () => {
    setSyncing(true)
    const result = await sync(folderId)
    setSyncing(false)
    setSyncOpen(false)
    if (result.success) {
      setSyncSuccess(result.data.screens_affected)
      await reloadData()
      setTimeout(() => setSyncSuccess(null), 6000)
    } else {
      setSyncError(true)
      setTimeout(() => setSyncError(false), 6000)
    }
  }

  const handleUnsync = async () => {
    setUnsyncing(true)
    const result = await unsync(folderId)
    setUnsyncing(false)
    setUnsyncOpen(false)
    if (result.success) {
      setUnsyncSuccess(result.data.screens_affected)
      await reloadData()
      setTimeout(() => setUnsyncSuccess(null), 6000)
    } else {
      setUnsyncError(true)
      setTimeout(() => setUnsyncError(false), 6000)
    }
  }

  const modalCopy = folderId ? (
    <>
      <p className='mb-0'>
        Synchronises all displays in this folder. They&rsquo;ll all start playing from the
        first slide at the same time in the next few minutes.
      </p>
    </>
  ) : (
    <>
      <p>
        Synchronises every display in your account, including displays inside folders.
        They&rsquo;ll all start playing from the first slide at the same time in the next
        few minutes.
      </p>
      <p className='mb-0'>
        If you only want to sync certain displays, add them to a folder and click the sync
        button inside that folder.
      </p>
    </>
  )

  const unsyncModalCopy = folderId ? (
    <>
      <p className='mb-0'>
        Removes all displays in this folder from the shared timeline. They&rsquo;ll return
        to independent playback within the next few minutes.
      </p>
    </>
  ) : (
    <>
      <p className='mb-0'>
        Removes all displays in your account from the shared timeline, including displays
        inside folders. They&rsquo;ll stop playing in sync and return to independent
        playback within the next few minutes.
      </p>
    </>
  )

  return (
    <>
      <Toolbar>
        <ToolbarGroup>
          {state.meta.usage.used < state.meta.usage.limit && (
            <div className='mr-1 mb-1'>
              <Tooltip label='Create a new display'>
                <Button
                  variant='success'
                  as={Link}
                  to={`/displays/create/${folderId ?? ''}`}>
                  Create
                </Button>
              </Tooltip>
            </div>
          )}

          {state.data.length > 0 && (
            <ButtonGroup className='mr-1 mb-1'>
              <Tooltip label='Sync displays'>
                <Button
                  variant='primary'
                  onClick={() => setSyncOpen(true)}
                  className='px-2'>
                  <Stopwatch />
                </Button>
              </Tooltip>
              <Tooltip label='Un-sync displays'>
                <Button
                  variant='secondary'
                  onClick={() => setUnsyncOpen(true)}
                  className='px-2'>
                  <StopwatchFill />
                </Button>
              </Tooltip>
            </ButtonGroup>
          )}
        </ToolbarGroup>

        {parentFolderId !== undefined && (
          <ToolbarGroup>
            <Tooltip label='Media Home'>
              <Button
                as={Link}
                to='/displays'
                variant='primary'
                className='mr-1 px-2 mb-1'>
                <House />
              </Button>
            </Tooltip>

            <Tooltip label='Back'>
              <Button
                as={Link}
                to={`/displays/${parentFolderId}`}
                variant='primary'
                className='mr-1 px-2 mb-1'>
                <ArrowLeftCircle />
              </Button>
            </Tooltip>
          </ToolbarGroup>
        )}

        <ToolbarGroup>
          {state.meta.folder.id !== '' && (
            <Badge
              variant='secondary'
              className='mr-1 px-2 d-flex align-items-center mb-1'>
              {state.meta.folder.name}
            </Badge>
          )}

          <CreateFolder
            type='SCREEN'
            parentFolderId={state.meta.folder.id}
            onSuccess={reloadData}
          />

          {state.meta.folder.id !== '' && (
            <>
              <UpdateFolder
                folderId={state.meta.folder.id}
                defaultName={state.meta.folder.name}
                onSuccess={reloadData}
              />

              <DeleteFolder
                folderId={state.meta.folder.id}
                name={state.meta.folder.name}
                onSuccess={reloadData}
              />
            </>
          )}
        </ToolbarGroup>
      </Toolbar>

      {syncSuccess !== null && (
        <Alert variant='success' className='mb-2'>
          Sync scheduled — {syncSuccess} {syncSuccess === 1 ? 'display' : 'displays'} will
          start playing in sync in the next few minutes.
        </Alert>
      )}

      {syncError && (
        <Alert variant='danger' className='mb-2'>
          Couldn&rsquo;t schedule sync. Please try again in a moment.
        </Alert>
      )}

      {unsyncSuccess !== null && (
        <Alert variant='success' className='mb-2'>
          Un-sync scheduled &mdash; {unsyncSuccess}{' '}
          {unsyncSuccess === 1 ? 'display' : 'displays'} will return to independent
          playback shortly.
        </Alert>
      )}

      {unsyncError && (
        <Alert variant='danger' className='mb-2'>
          Couldn&rsquo;t schedule un-sync. Please try again in a moment.
        </Alert>
      )}

      <Modal
        size='lg'
        show={syncOpen}
        onHide={() => setSyncOpen(false)}
        aria-labelledby='sync-displays-modal-title'>
        <Modal.Header closeButton>
          <Modal.Title id='sync-displays-modal-title'>Sync Displays</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalCopy}</Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setSyncOpen(false)}>
            Cancel
          </Button>
          <LoaderButton
            loading={syncing}
            label='Sync'
            onClick={handleSync}
            variant='success'
          />
        </Modal.Footer>
      </Modal>

      <Modal
        size='lg'
        show={unsyncOpen}
        onHide={() => setUnsyncOpen(false)}
        aria-labelledby='unsync-displays-modal-title'>
        <Modal.Header closeButton>
          <Modal.Title id='unsync-displays-modal-title'>Un-sync Displays</Modal.Title>
        </Modal.Header>
        <Modal.Body>{unsyncModalCopy}</Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setUnsyncOpen(false)}>
            Cancel
          </Button>
          <LoaderButton
            loading={unsyncing}
            label='Un-sync'
            onClick={handleUnsync}
            variant='warning'
          />
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Screens
